import React from "react";
import StepBar from "./styles";

// so we can add steps with same title without adding to the UI step progress bar

const StepProgressBar = ({ currentStep, listOfSteps, activeStep }) => (
  <StepBar>
    {listOfSteps.map((step, index) => (
      <li key={index} className={activeStep === index + 1 ? `active` : ``}>
        <div>
          <span>{step}</span>
        </div>
      </li>
    ))}
  </StepBar>
);
StepProgressBar.displayName = "StepProgressBar";

export default StepProgressBar;
